/**
 * Maps page keys / paths used by the onboarding agent to dashboard routes.
 */
const PAGE_MAP = {
  dashboard: "/dashboard",
  home: "/dashboard",
  dialer: "/dashboard/dialer",
  "call-routings": "/dashboard/call-routings",
  routes: "/dashboard/call-routings",
  "create-route": "/dashboard/create-route",
  channels: "/dashboard/channels",
  recordings: "/dashboard/recordings",
  contacts: "/dashboard/contacts",
  settings: "/dashboard/settings/organization",
  "settings/users": "/dashboard/settings/users",
  "settings/organization": "/dashboard/settings/organization",
  "settings/twilio": "/dashboard/settings/twilio-integration",
  "settings/twilio-integration": "/dashboard/settings/twilio-integration",
  "settings/billing": "/dashboard/settings/billing",
  "settings/account": "/dashboard/settings/account",
  users: "/dashboard/settings/users",
};

const PATH_LABELS = [
  [/^\/dashboard\/create-route\/?$/, "Create route"],
  [/^\/dashboard\/call-route\//, "Edit route"],
  [/^\/dashboard\/call-routings\/?$/, "Call routings"],
  [/^\/dashboard\/dialer\/?$/, "Dialer"],
  [/^\/dashboard\/channels\/?$/, "Channels"],
  [/^\/dashboard\/recordings\/?$/, "Recordings"],
  [/^\/dashboard\/contacts\/?$/, "Contacts"],
  [/^\/dashboard\/call-details\//, "Call details"],
  [/^\/dashboard\/settings\/users\/?$/, "Users settings"],
  [/^\/dashboard\/settings\/organization\/?$/, "Organization settings"],
  [/^\/dashboard\/settings\/twilio/, "Twilio settings"],
  [/^\/dashboard\/settings\/billing\/?$/, "Billing"],
  [/^\/dashboard\/settings\/account\/?$/, "Account settings"],
  [/^\/dashboard\/?$/, "Dashboard"],
];

export function describeDashboardPath(pathname) {
  if (!pathname || typeof pathname !== "string") {
    return { path: "", page_label: "Unknown" };
  }
  const path = pathname.split("?")[0] || pathname;
  for (const [re, label] of PATH_LABELS) {
    if (re.test(path)) return { path, page_label: label };
  }
  if (path.startsWith("/dashboard")) {
    return { path, page_label: "Dashboard" };
  }
  return { path, page_label: path };
}

export function resolveNavigatePath(page, highlightCallId) {
  if (!page || typeof page !== "string") {
    throw new Error("page is required");
  }
  const key = page.trim().replace(/^\/+/, "");
  const mapped =
    PAGE_MAP[page] ||
    PAGE_MAP[key] ||
    PAGE_MAP[key.replace(/^dashboard\//, "")] ||
    null;

  let path = mapped;
  if (!path) {
    if (page.startsWith("/dashboard")) path = page;
    else if (page.startsWith("dashboard/")) path = `/${page}`;
    else if (page.startsWith("/")) path = page;
    else path = `/dashboard/${key}`;
  }

  if (highlightCallId) {
    if (path === "/dashboard" || path === "/dashboard/") {
      return `/dashboard/call-details/${encodeURIComponent(highlightCallId)}`;
    }
  }
  return path;
}

export { PAGE_MAP };
